import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';
import { warehouseClientId, warehouseTenantId } from '../environment/environment';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: warehouseClientId, // This is the ONLY mandatory field that you need to supply (static web app ID)
        authority: `https://login.microsoftonline.com/${warehouseTenantId}/`, // Defaults to "https://login.windows-ppe.net/common" /tenantID
        redirectUri: window.location.origin, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};

export const loginPopupRequest: PopupRequest = {
    scopes: ['User.Read', 'User.Read.All'],
    extraScopesToConsent: ['api://958172be-5d3d-4302-8a7c-015f688a298c/Warehouse.Read'],
};

export const protectedResources = {
    warehouseApi: {
        scopes: ['api://958172be-5d3d-4302-8a7c-015f688a298c/Warehouse.Read'],
    },
    graphMe: {
        endpoint: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['User.Read'],
    },
};
